<template>
  <span>{{message}}</span>
</template>

<script>
  const toDou = n => {
    return n > 9 ? n : '0' + n
  };
  export default {
    data() {
      return {
        message: '',
        targetTime: 0,
        timer: null
      }
    },
    props: {
      time: {},
      prefix: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      }
    },
    created(){
      this.showChangeTime(this.time)
    },
    watch: {
      time(val){
        this.showChangeTime(val)
      }
    },
    methods: {
      showChangeTime(time){
        if (time){
          let oTarget = new Date(time);
          this.targetTime = oTarget.getTime();
          this.tick();
          this.timer = setInterval(()=>{
            this.tick();
          },1000)
        }
      },
      tick(){
        let oDate = new Date();
        let sToday=oDate.getTime();
        let dis = parseInt((this.targetTime-sToday)/1000);
        if(dis<=0){
          clearInterval(this.timer);
          if(this.id){
            this.$emit('update:status',true);
          }
          this.message ="已结束";
          // this.$emit()
          return;
        }
        let d = parseInt(dis/86400);
        let s =dis%86400;
        let h = parseInt(s/3600);
        s=s%3600;
        let m = parseInt(s/60);
        s=s%60;
        if(d>0){
          this.message = this.prefix+ ' '+d+"天"+h+"时"+toDou(m)+"分"+toDou(s)+"秒"
        }else{
          this.message = this.prefix+ ' '+h+"小时"+toDou(m)+"分"+toDou(s)+"秒"
        }
      }
    }
  }
</script>

<style scoped>

</style>
